module.exports = __webpack_public_path__ + "img/5.45262f60.jpg";